var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherConfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "otherConfIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 282",
    transform: "translate(655 46)",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h36v36H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "otherConfIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 383",
    fill: "none",
    d: "M0 0h36v36H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "OtherIcon",
    transform: "translate(-655 -46)",
    clipPath: "url(#otherConfIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "OtherIcon",
    transform: "translate(655 46)",
    clipPath: "url(#otherConfIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 381"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 538",
    d: "M10.469 9.484a1.922 1.922 0 01.32 1.242 1.855 1.855 0 01-.255 1.022.971.971 0 01-.864.464 1.072 1.072 0 01-.854-.393 1.669 1.669 0 01-.3-1.086 2.408 2.408 0 01.147-.864 1.141 1.141 0 01.447-.594.971.971 0 01.529-.156 1.132 1.132 0 01.454.1 1.025 1.025 0 01.372.27",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 539",
    d: "M27.917 5.425H8.083A5.084 5.084 0 003 10.508v.334a5.084 5.084 0 005.083 5.083h19.834A5.082 5.082 0 0033 10.842v-.334a5.083 5.083 0 00-5.083-5.083m-.188 9.246a3.825 3.825 0 113.825-3.825 3.825 3.825 0 01-3.825 3.825m-16.645-2.384a1.816 1.816 0 01-1.408.571 2.242 2.242 0 01-.968-.21 1.6 1.6 0 01-.787-.777 2.72 2.72 0 01-.249-1.171 2.613 2.613 0 01.276-1.2 1.816 1.816 0 011.765-1.009 1.735 1.735 0 011.377.567 2.117 2.117 0 01.389.7 2.9 2.9 0 01.152.951 2.257 2.257 0 01-.546 1.583m5.163.436h-.978L13.429 9.5v3.228h-.756V8.615H13.7l1.767 3.024V8.615h.777z",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 540",
    d: "M27.728 6.8a4.05 4.05 0 104.05 4.05 4.05 4.05 0 00-4.05-4.05m0 7.875a3.825 3.825 0 113.825-3.825 3.825 3.825 0 01-3.825 3.825",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 541",
    d: "M27.728 6.571A4.275 4.275 0 1032 10.846a4.275 4.275 0 00-4.275-4.275m0 8.1a3.825 3.825 0 113.825-3.825 3.825 3.825 0 01-3.825 3.825",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 542",
    d: "M27.917 19.775H8.083A5.39 5.39 0 002.7 25.159v.333a5.39 5.39 0 005.384 5.384h19.833a5.389 5.389 0 005.383-5.384v-.333a5.389 5.389 0 00-5.382-5.383m4.782 5.716a4.788 4.788 0 01-4.782 4.783H8.083A4.79 4.79 0 013.3 25.492v-.333a4.789 4.789 0 014.784-4.783h19.833a4.787 4.787 0 014.783 4.783z",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 543",
    d: "M8.228 21.694a3.675 3.675 0 103.672 3.675 3.675 3.675 0 00-3.675-3.675m0 6.843a3.168 3.168 0 113.175-3.168 3.168 3.168 0 01-3.168 3.168",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 544",
    d: "M20.366 24.448a2.128 2.128 0 00-.389-.7 1.736 1.736 0 00-1.377-.567 1.815 1.815 0 00-1.765 1.01 2.608 2.608 0 00-.276 1.2 2.708 2.708 0 00.249 1.171 1.592 1.592 0 00.788.779 2.26 2.26 0 00.968.21 1.818 1.818 0 001.409-.571 2.257 2.257 0 00.546-1.583 2.9 2.9 0 00-.152-.951m-.945 1.993a.97.97 0 01-.864.463 1.069 1.069 0 01-.854-.395 1.655 1.655 0 01-.3-1.085 2.438 2.438 0 01.146-.864 1.142 1.142 0 01.45-.59.975.975 0 01.53-.157 1.121 1.121 0 01.453.1.985.985 0 01.373.27 1.922 1.922 0 01.318 1.242 1.859 1.859 0 01-.253 1.022",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 545",
    d: "M24.4 23.984v-.675h-2.84v4.109h.761v-1.674h1.912v-.68h-1.912v-1.08z",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 546",
    d: "M28.244 23.984v-.675h-2.835v4.109h.762v-1.674h1.911v-.68h-1.911v-1.08z",
    fill: "#231815"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherConfIcon);
export default __webpack_public_path__ + "static/media/otherConfIcon.d2388aa1e3f89605.svg";
export { ForwardRef as ReactComponent };